import {ApolloClient, gql, NormalizedCacheObject, useQuery} from '@apollo/client';
import {Query} from '../types/generated/graphql';

/**
 * Per-backend-service heartbeat rows. Polls every 30s so a deploy
 * shows up in the panel within half a minute without manual
 * refresh. Cache-and-network so an instant refresh still uses the
 * last good response while the new one is in flight.
 */
export const useGetServiceHealth = (
  client: ApolloClient<NormalizedCacheObject>,
) => {
  type T = Pick<Query, 'getServiceHealth'>;
  return useQuery<T>(QUERY, {
    client,
    fetchPolicy: 'cache-and-network',
    pollInterval: 30_000,
  });
};

const QUERY = gql`
  query getServiceHealth {
    getServiceHealth {
      key
      sha
      shortSha
      subject
      branch
      commitDate
      builtAt
      dirty
      bootedAt
      lastSeenAt
    }
  }
`;
